import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';

import { PagesRouter } from '../PagesRouter';
import { IReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ScrollingContextProvider } from '../Scrolling';
import { ApplicationContext } from '../../utils/applicationContext';

export interface IApplicationProps {
  reduxStore: IReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { context, reduxStore } = props;

  return (
    <ApplicationContext.Provider value={context}>
      <ErrorLogComponent logger={context.logger}>
        <Provider store={reduxStore}>
          <ScrollingContextProvider>
            <PagesRouter />
          </ScrollingContextProvider>
        </Provider>
      </ErrorLogComponent>
    </ApplicationContext.Provider>
  );
};
